import { apiRequest } from 'api/apiClient';

const checkVanityUrlAvailability = async (vanityUrl) => {
  const response = await apiRequest(
    'GET',
    `/v1/vanity-url/check/${encodeURIComponent(vanityUrl)}`,
    null,
  );
  return response;
};

const VANITY_URL_QUERIES = {
  CHECK_AVAILABILITY: checkVanityUrlAvailability,
};

export default VANITY_URL_QUERIES;
